import React, {Component, Fragment} from 'react';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            background_image_url: '',
            screen_size: '',
            imageSize: 'lg',
        }
        this.image_url = this.image_url.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.image_url();
    }

    componentDidMount() {
        window.addEventListener("resize", this.image_url);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.image_url);
    }

    componentDidUpdate(prevProps) {
        if (this.props.background_image_id !== prevProps.background_image_id) {
            this.image_url();
            return true;
        }
        if (this.props.fallbackBackgroundImage !== prevProps.fallbackBackgroundImage) {
            this.image_url();
            return true;
        }
    }

    image_url() {
        let screen_size = 'XS';
        let background_image_url = '';
        let imageSize = (window.innerHeight > 700) ? 'lg' : 'sm';

        let background_image_id = this.props.background_image_id;
        let imageDetails = this.props.images.find((el) => {
            return el.media_id === background_image_id;
        });

        if (background_image_id && undefined !== imageDetails) {
            background_image_url = (imageSize === 'lg') ? imageDetails.url : imageDetails.url_md;
        } else if(this.props.background_image){
            background_image_url = this.props.background_image;
        } else if( this.props.fallbackBackgroundImage ){
            background_image_url = (imageSize === 'lg') ? this.props.fallbackBackgroundImage.url : this.props.fallbackBackgroundImage.url_md;
        }

        if (this.state.imageSize !== imageSize || this.state.background_image_url !== background_image_url) {
            this.setState(
            {
                screen_size: screen_size,
                imageSize: imageSize,
                background_image_url: background_image_url,
            });
        }
    }

    render() {
        return (
            <Fragment>
                <div
                    style={{
                        position: 'fixed',
                        left: 0,
                        top: 0,
                        zIndex: '-1',
                        height: '100%',
                        width: '100%',
                        backgroundSize: 'cover',
                        backgroundImage: 'url(' + this.state.background_image_url + ')',
                        backgroundPosition: 'center center'
                    }}></div>
                <div className="page-header header">
                    <div className="header-content">
                        <h2 className="title">{this.props.title}</h2>
                        <h3 className="subtitle">{this.props.subTitle}</h3>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default Header;
